/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_PhoneInputs */

const cs_form_phone = /** @type {(inputs: Form_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const en_form_phone = /** @type {(inputs: Form_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Form_PhoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_phone = /** @type {((inputs?: Form_PhoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_PhoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_phone(inputs)
	return cs_form_phone(inputs)
});